import { Box, Typography } from '@mui/material';
import React from 'react';
import { CortisolHistoryCard } from './CortisolHistoryCard';
import { HormoneSnapshot } from '../../../types';
import { ProgressTracking } from './ProgressTracking';

export const StressProgress = ({
  snapshots,
}: {
  snapshots: HormoneSnapshot[];
}): JSX.Element => {
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="light" fontSize={14} sx={{ mt: 3 }}>
        Monitoring your journey is essential for insight and motivation. Witness
        the transformation as you journey towards balance.
      </Typography>
      {/* TODO: Bring this back when a new Cortisol Test is available */}
      {/* <ProgressTracking snapshots={snapshots} /> */}
      <CortisolHistoryCard snapshots={snapshots} />
    </Box>
  );
};
